import React, { useState } from "react";
import "./MyProfile.css";
import Availability from "../availability/Availability";

const MyProfile = () => {
  const [selectedOption, setSelectedOption] = useState("Availability");

  return (
    <div className="table_component_main_container">
      {/* <div className="my_profile_opts" style={{ flex: 1}}> */}
        {/* <div
          className={"my_profile_option" + (selectedOption == "Personal info" ? " my_profile_opt_selected" : "")}
          onClick={() => setSelectedOption("Personal info")}
        >
          Personal info
        </div>
        <div
          className={"my_profile_option" + (selectedOption == "Notifications" ? " my_profile_opt_selected" : "")}
          onClick={() => setSelectedOption("Notifications")}
        >
          Notifications
        </div> */}
        {/* <div
          className={"my_profile_option" + (selectedOption === "Availability" ? " my_profile_opt_selected" : "")}
          onClick={() => setSelectedOption("Availability")}
        >
          Availability
        </div> */}
        {/* <div
          className={"my_profile_option" + (selectedOption == "Licence" ? " my_profile_opt_selected" : "")}
          onClick={() => setSelectedOption("Licence")}
        >
          Licence
        </div>
        <div
          className={"my_profile_option" + (selectedOption == "Email" ? " my_profile_opt_selected" : "")}
          onClick={() => setSelectedOption("Email")}
        >
          Email
        </div>
        <div
          className={"my_profile_option" + (selectedOption == "Password" ? " my_profile_opt_selected" : "")}
          onClick={() => setSelectedOption("Password")}
        >
          Password
        </div> */}
      {/* </div> */}
      <div className="table_scrollable_container_new" style={{border: 'none'}}>
        <div className="table_scrollable_inner_container">
        <Availability />
      </div>
    </div>
    </div>
  );
};

export default MyProfile;
